import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import LeafImg from '../../../../assets/tree/leaf.svg';
import { NEXT_CHALLENGE_ROUTE } from '../../../../constants/routes.constants';
import { useHistory } from 'react-router-dom';

const getBranchClassName = (index) => {
  switch (index) {
    case 0:
      return 'one';
    case 1:
      return 'two';
    case 2:
      return 'three';
    case 3:
      return 'four';
    case 4:
      return 'five';
    case 5:
      return 'six';
    case 6:
      return 'seven';
    case 7:
      return 'eight';
    case 8:
      return 'nine';
    case 9:
      return 'ten';
    default:
      return 'unknown'; // Default case for any index not covered
  }
};

const TreeInterestBranches = ({
  branchesList,
  updatedBranches,
  isGuardianDashboard = false,
}) => {
  const [isRemoveHover, setIsRemoveHover] = useState(false);
  const history = useHistory();
  const handleClick = (tag) => {
    if (!isGuardianDashboard) {
      history.push({
        pathname: NEXT_CHALLENGE_ROUTE,
        state: {
          tag: tag,
          filter: 'tag',
        },
      });
    } else {
      return;
    }
  };

  useEffect(() => {
    window.onclick = () => {
      setIsRemoveHover(true);
    };
    return () => {
      window.onclick = null;
    };
  }, []);
  let newData = isRemoveHover ? [] : updatedBranches.map((update) => update.id);
  return branchesList.map((branch, key) => {
    return (
      <Box
        sx={{
          position: 'absolute',
          ': hover': {
            transform:
              newData.includes(branch.id) && 'skew(0deg, -7deg) !important',
          },
        }}
        className={`tree-branches-wrapper ${getBranchClassName(key)}`}
        onClick={() => handleClick(branch.tag)}
      >
        <Box
          sx={{
            padding: isGuardianDashboard ? '2% 2%' : '5% 7%',
            boxShadow:
              newData.includes(branch.id) && '0 0 50px 3px #f78bc9 !important',
            transform: newData.includes(branch.id) && 'skew(0deg, 7deg)',
          }}
          className={`tree-branches ${getBranchClassName(key)}`}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              fontSize: isGuardianDashboard ? '8px' : '12px',
            }}
          >
            {branch.tag}
          </Typography>
        </Box>
        {!isGuardianDashboard && (
          <Box
            component="img"
            className="leaf-img"
            display={newData.includes(branch.id) && 'block !important'}
            src={LeafImg}
          />
        )}
      </Box>
    );
  });
};

export default TreeInterestBranches;
